const RECENT_CHECKLIST_LIMIT = 5;

export function checklistIdentity(entry) {
  if (!entry?.sport || !entry?.year || !entry?.manufacturer || !entry?.series) {
    return null;
  }
  return `${entry.sport}/${entry.year}/${entry.manufacturer}/${entry.series}`;
}

/**
 * Move a viewed checklist to the front of a newest-first list, capped at 5.
 * Returns the same list reference when the entry is already newest.
 */
export function buildRecentChecklists(current, entry, updatedAt = new Date().toISOString()) {
  const list = Array.isArray(current) ? current : [];
  const identity = checklistIdentity(entry);
  if (!identity) {
    return { list, changed: false };
  }
  if (checklistIdentity(list[0]) === identity) {
    return { list, changed: false };
  }

  const nextEntry = {
    sport: entry.sport,
    year: entry.year,
    manufacturer: entry.manufacturer,
    series: entry.series,
    updatedAt,
  };

  return {
    list: [nextEntry, ...list.filter((item) => checklistIdentity(item) !== identity)].slice(0, RECENT_CHECKLIST_LIMIT),
    changed: true,
  };
}
